import { DishRatingFilter } from 'common/DishRatingFilter';
import { DateString } from 'common/UrlDate';
import { useMemo } from 'react';
import {
  BrowseFilter,
  DishFirstSegmentFilter,
  FoodTypeCoalesced,
  PriceLevel,
  Protein,
  TagFilter,
} from 'src/gqlReactTypings.generated.d';
import { SpiceLevelOptions } from 'src/shared/Enums';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';

export interface Filters {
  availabilityDates: DateString[];
  browseFilter: BrowseFilter | null;
  dietaryFilters: string[];
  dishTypeFilters: FoodTypeCoalesced[];
  spiceLevelFilters: SpiceLevelOptions[];
  proteinFilters: Protein[];
  minDishRating: DishRatingFilter;
  cuisineFilters: string[];
  segmentFilters: DishFirstSegmentFilter[] | null;
  isEcoFriendlyPackaging: boolean;
  priceLevelFilters: PriceLevel[];
  tagFilters: TagFilter[];
}
export const useDishFirstExploreFilters = (rawFilters: Filters) => {
  const { isSmallScreen } = useScreenContext();

  const stringifiedFilters = useMemo(
    () =>
      JSON.stringify({
        smallScreen: isSmallScreen,
        ...rawFilters,
      }),
    [isSmallScreen, rawFilters]
  );

  const filters: Filters = useMemo(() => ({ tagFilters: [], ...JSON.parse(stringifiedFilters) }), [stringifiedFilters]);

  return {
    filters,
    stringifiedFilters,
  };
};
